import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { rootActions } from "../../actions/rootActions";
import {
  eAccDoiTuongKhongTinhHocPhiActionIds,
  IAccDoiTuongKhongTinhHocPhiActionTypes,
} from "../../action-types/category/IDoiTuongKhongTinhHocPhiActions";
import { IAccDoiTuongKhongTinhHocPhi } from "../../../model/respone/category/IAccDoiTuongKhongTinhHocPhi";
import { monKhongTinhHocPhiApi } from "../../../api/category/monKhongTinhHocPhiApi";
import { doiTuongKhongTinhHocPhiApi } from "../../../api/category/doiTuongKhongTinhHocPhiApi";

export function* doiTuongKhongTinhHocPhiSaga(): any {
  yield takeLatest(eAccDoiTuongKhongTinhHocPhiActionIds.LOAD_START, loadWorker);
  yield takeEvery(eAccDoiTuongKhongTinhHocPhiActionIds.SAVE_START, saveWorker);
  yield takeEvery(
    eAccDoiTuongKhongTinhHocPhiActionIds.DELETE_START,
    deleteWorker,
  );
}

function* loadWorker(): any {
  const res: IBaseRespone = yield call(doiTuongKhongTinhHocPhiApi.SelectAll);
  if (res.is_success) {
    yield put(
      rootActions.category.doiTuongKhongTinhHocPhi.LOAD_SUCCESS(res.data),
    );
  } else {
    yield put(
      rootActions.category.monKhongTinhHocPhi.LOAD_ERRR(
        res.message ?? "Có lỗi",
      ),
    );
  }
}
function* saveWorker(action: IAccDoiTuongKhongTinhHocPhiActionTypes): any {
  let res: IBaseRespone;
  const payload = action.payload as IAccDoiTuongKhongTinhHocPhi;
  if (payload.id > 0) {
    res = yield call(doiTuongKhongTinhHocPhiApi.Update, payload);
  } else {
    res = yield call(doiTuongKhongTinhHocPhiApi.Insert, payload);
  }
  if (res) {
    if (res.is_success) {
      yield put(
        rootActions.category.doiTuongKhongTinhHocPhi.SAVE_SUCCESS(res.data),
      );
    } else {
      yield put(
        rootActions.category.doiTuongKhongTinhHocPhi.SAVE_ERROR(
          res.message ?? "Có lỗi",
        ),
      );
    }
  }
}

function* deleteWorker(action: IAccDoiTuongKhongTinhHocPhiActionTypes): any {
  const res: IBaseRespone = yield call(
    doiTuongKhongTinhHocPhiApi.Delete,
    action.payload as number,
  );
  if (res.is_success) {
    yield put(
      rootActions.category.doiTuongKhongTinhHocPhi.DELETE_SUCCESS(res.data),
    );
  } else {
    yield put(
      rootActions.category.doiTuongKhongTinhHocPhi.DELETE_ERROR(
        res.message ?? "Có lỗi",
      ),
    );
  }
}
